import coreAPIInstance from "./coreApiInstance";

export const coreClipAPIs = {
  getCoreClipDetails: ({ payload }) => coreAPIInstance.post(`/api/v1/clip.details`, payload),
  getCoreClipsDetails: ({ payload }) => coreAPIInstance.post(`/api/v1/clip.list.details`, payload),
  cutCoreClip: ({ payload }) => coreAPIInstance.post(`/api/v1/clips/process`, payload),
  uploadClip: ({ payload }) => coreAPIInstance.post(`/api/v1/clip-uploads/upload.clip`, payload),
  getUploadedClipDetail: ({ payload }) =>
    coreAPIInstance.get(`/api/v1/clip-uploads/upload.clip/${payload.uploadedClipId}`, {
      headers: {
        entityId: payload.entityId,
      },
    }),
  getMergeClipDetails: ({ payload }) => coreAPIInstance.post(`/api/v1/clips/merge-sources`, payload),
};
